// src/components/Privacy.js
export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 bg-white shadow rounded text-gray-800">
      <h1 className="text-2xl font-bold border-l-4 border-[#07cc55] pl-3 mb-6">プライバシーポリシー</h1>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">1. 個人情報の利用目的</h2>
      <p>
        当サイトでは、ユーザーの皆様から個人情報（氏名・メールアドレス等）を取得することは原則ありません。
        お問い合わせ時に取得する場合は、以下の目的で利用いたします。
      </p>
      <ul className="list-disc list-inside ml-4">
        <li>お問い合わせへの対応</li>
        <li>必要に応じたご連絡</li>
      </ul>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">2. アクセス解析ツールについて</h2>
      <p>
        当サイトでは、Google社が提供するアクセス解析ツール「Google Analytics」を利用しています。
        このツールは、トラフィックデータ収集のためにCookieを使用しており、匿名で収集され、個人を特定するものではありません。
        詳細は
        <a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank" rel="noopener noreferrer" className="text-[#269d53] underline">
          Google Analyticsの利用規約
        </a>
        をご覧ください。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">3. アフィリエイトプログラムについて</h2>
      <p>
        当サイトは、Amazon.co.jpを宣伝・紹介することを目的としたアフィリエイトプログラム「Amazonアソシエイト」に参加しています。
        このプログラムにより、当サイトは適格販売により報酬を得る場合があります。
        アフィリエイトリンクを通じて商品を購入された際、第三者が情報を収集することがありますが、これらは個人を特定する情報には該当しません。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">4. Cookieの使用について</h2>
      <p>
        当サイトでは、上記ツールやプログラムの利用に伴い、Cookieを使用しています。
        Cookieは、ユーザーのブラウザに一時的に保存される小さなデータファイルで、ユーザー個人を特定するものではありません。
        Cookieの使用を希望されない場合は、お使いのブラウザ設定から無効にすることも可能です。
        ただし、その場合一部機能が正しく動作しないことがあります。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">5. 免責事項</h2>
      <p>
        当サイトのコンテンツ・情報は可能な限り正確な情報を掲載するよう努めておりますが、正確性や安全性を保証するものではありません。
        リンク先の他サイトにおける情報・サービスについても一切の責任を負いかねます。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">6. プライバシーポリシーの変更について</h2>
      <p>
        本ポリシーの内容は、必要に応じて変更されることがあります。変更後のポリシーは、当ページにて速やかに公開いたします。
      </p>

      <h2 className="text-lg font-semibold text-[#269d53] mt-6">7. お問い合わせ</h2>
      <p>
        プライバシーポリシーに関するご質問がございましたら、以下のメールアドレスまでご連絡ください。
      </p>
      <p className="mt-2 text-sm text-gray-600">
        📧 <a href="mailto:info@bodogeshindan.jp" className="text-[#269d53] underline">info@bodogeshindan.jp</a>
      </p>
    </div>
  );
}
